import {
    DASHBOARD_ERROR_REQUEST,
    DASHBOARD_ERROR_SUCCESS ,
    DASHBOARD_ERROR_ERROR,
    DASHBOARD_ERROR_CHANGE_COUNT,
    DASHBOARD_ERROR_CHANGE,
    DASHBOARD_ERROR_FILTERS_RESET,
    DASHBOARD_ERROR_FILTERS_CHANGE,
    DASHBOARD_ERROR_RESET,
    DASHBOARD_ERROR_RESET_DATA
} from "../actions/dashboardErrorActions";

import {CookiesSettings} from '../helpers/cookiesHelper'

let cookiesSetting = new CookiesSettings("dashboardError")

let count = cookiesSetting.get("count");
if(!count){
    count = 15
    cookiesSetting.set("count",count)
}

const initialState = {    
    companyId:1,
    source:2,
    sortOrder:0,    
    data:[],
    page:1,
    count:count,
    total:0,
    fetching:false,
    set:false,
    needRefresh: false,
    size:20,
    filters:{
        bindingType:"0",
        isAvailable:0,
        isActive:0,
        offerName:"",
        offerId:"",
        periodStart:null,
        periodEnd:null
    }
}

export default function dashbordError(state=initialState, action) {
    let {data} = state;
    switch (action.type){
        case DASHBOARD_ERROR_REQUEST:
            return{
                ...state,
                fetching:true,
                needRefresh:false
            }
        case DASHBOARD_ERROR_ERROR:
            return{
                ...state,
                fetching:false,
                data:initialState.data
            }
        case DASHBOARD_ERROR_SUCCESS:
            return{
                ...state,
                fetching:false,
                set:true,
                data:action.payload.rows,
                total:action.payload.totalNumberOfResults
            }
        case DASHBOARD_ERROR_CHANGE_COUNT:
            cookiesSetting.set("count",action.payload)
            return{
                ...state,
                needRefresh:true,
                page:1,
                count:action.payload
            }
        case DASHBOARD_ERROR_CHANGE:
            return{
                ...state,
                [action.payload.field]:action.payload.value
            }
        case DASHBOARD_ERROR_FILTERS_RESET:
            return{
                ...state,
                needRefresh:true,
                page:initialState.page,
                filters:initialState.filters,
                offerId:initialState.offerId
            }
        case DASHBOARD_ERROR_FILTERS_CHANGE:
            return{
                ...state,
                needRefresh:true,
                page:initialState.page,
                filters:action.payload
            }
        case DASHBOARD_ERROR_CHANGE:
            return{
                ...state,
                [action.payload.field]:action.payload.value
            }
        case DASHBOARD_ERROR_RESET:
            let count = state.count;
            return {
                ...initialState,
                count
            }
        case DASHBOARD_ERROR_RESET_DATA:
            return {
                ...state,
                data:initialState.data,
                total:initialState.total,
                page:initialState.page,

            }        
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/dashboardError.js